import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import AppNavbar from "../../../components/common/AppNavbar";

const USImmigration2026 = () => {
  return (
    <>
      <AppNavbar />
      <div style={{ background: "#f4f7fb" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="danger" className="mb-3">
              U.S. Immigration Feb 2026
            </Badge>
            <h1 className="fw-bold">
              2026 U.S. Immigration Policies affecting Indian/Bharat Nationals
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              Historic employment-based green card movement contrasts with
              tougher H-1B rules, higher fees, and stricter enforcement for
              Indian/Bharat nationals under intensified 2026 policies.
            </p>
          </Container>
        </div>

        <section class="us-immigration-2026">
          <div class="container py-5">
            {/* <h2>
              U.S. Immigration Changes 2026 – Impact on Indian/Bharat Nationals
            </h2> */}

            <p>
              While employment-based green card categories saw unexpected
              forward movement, temporary work visas and family-based
              immigration have become more restrictive, more expensive, and more
              heavily vetted under intensified enforcement policies.
            </p>

            <p>
              Below is an overview of the most significant 2026 policy shifts
              affecting Indian workers, students, families, and long-term
              residents.
            </p>

            <hr />

            <h3>1. Green Card (Employment-Based) Advancements</h3>

            <h4>Massive EB-2 India Leap</h4>
            <p>
              The March 2026 Visa Bulletin provided an 11-month advancement in
              the EB-2 final action date for India, moving it to November 1,
              2014.
            </p>

            <h4>EB-1 India Movement</h4>
            <p>
              The EB-1 category for India advanced to December 1, 2023, offering
              faster processing for individuals with extraordinary ability,
              outstanding researchers, and multinational executives.
            </p>

            <h4>Adjustment of Status (I-485) Filing</h4>
            <p>
              USCIS enabled Indian nationals to use the “Dates for Filing” chart
              in March 2026, allowing many to submit Form I-485 applications.
            </p>

            <p>Filing I-485 provides eligibility for:</p>

            <ul>
              <li>Employment Authorization Document (EAD)</li>
              <li>Advance Parole (travel authorization)</li>
              <li>
                Pending adjustment status while awaiting final green card
                approval
              </li>
            </ul>

            <h4>Backlog Realities</h4>
            <p>
              Despite advancements, over 1 million Indian nationals remain in
              the employment-based backlog. Demand continues to exceed annual
              visa limits, meaning further volatility or retrogression remains
              possible.
            </p>

            <hr />

            <h3>2. H-1B Visa Changes (Temporary Worker)</h3>

            <h4>New “Weighted” Lottery Rule</h4>
            <p>
              Effective February 27, 2026, the H-1B lottery prioritizes
              higher-paid, mid-career professionals over entry-level positions,
              making it harder for recent graduates and early-career applicants.
            </p>

            <h4>Increased Fees and Costs</h4>
            <ul>
              <li>H-1B registration fee increased to $215.</li>
              <li>
                New $100,000 payment requirement for certain petitions filed
                after September 20, 2025.
              </li>
              <li>Additional $250 non-waivable “Visa Integrity Fee.”</li>
            </ul>

            <h4>Stricter Vetting</h4>
            <p>
              Enhanced social media and online presence screening applies to
              H-1B and H-4 applicants. A centralized USCIS Vetting Center
              conducts additional fraud and public safety reviews.
            </p>

            <hr />

            <h3>3. Family-Based & Other Visa Changes</h3>

            <h4>Suspension / Pause on Visas</h4>
            <p>
              Effective January 21, 2026, immigrant visa processing was
              suspended for 75 countries classified as high-risk for public
              benefits usage. While India is not on the primary list, stricter
              “public charge” screening now applies broadly.
            </p>

            <h4>Spousal and Child Sponsorship Limits</h4>
            <p>
              A December 2025 Proclamation restricts U.S. citizens from
              sponsoring certain family members from designated high-risk
              countries, impacting spousal and parental immigration in affected
              regions.
            </p>

            <h4>Increased Scrutiny at Ports of Entry</h4>
            <p>
              CBP expanded its Biometric Entry/Exit program, increasing facial
              recognition screening at airports and land ports, which may result
              in longer processing times for visa holders.
            </p>

            <hr />

            <h3>Summary of Impact for Indian/Bharat Nationals</h3>

            <p>The 2026 immigration landscape presents a dual reality:</p>

            <ul>
              <li>
                Historic forward movement in employment-based green card
                categories
              </li>
              <li>Higher costs and stricter vetting for temporary visas</li>
              <li>Expanded digital and biometric enforcement</li>
              <li>Increased scrutiny in family-based immigration pathways</li>
            </ul>

            <p>
              Indian nationals with established priority dates stand to benefit
              the most from green card advancements, while new applicants face
              some of the most competitive and costly barriers in decades.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default USImmigration2026;
